import moment from 'moment';

export const makeSubheaderFromDates = ({
  createdAt,
  updatedAt,
}: {
  createdAt: string;
  updatedAt: string;
}) => {
  const delayFromPublication = moment(new Date(createdAt)).fromNow();
  const delayFromUpdate = moment(new Date(updatedAt)).fromNow();
  const updatedText = s__('Forum|Updated %{delay}').i__({
    delay: delayFromUpdate,
  });

  return `${delayFromPublication}${
    delayFromPublication !== delayFromUpdate ? ` · ${updatedText}` : ''
  }`;
};
